module.exports = __webpack_public_path__ + "static/media/20.55fdaf3a.jpg";